export default "__VITE_ASSET__BRAGU1Pl__"